<button class="boton" 
  title="Regresar al principio de la página"
  (click)="subir($event)">
  <fa-icon [icon]="icon"></fa-icon>
</button>
